import { useApi } from '~shared/providers/use-api';

import type { UseMutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

import type { DocumentApi } from '../api/document-api';

export const useGenerateDocumentMutation = (
  options?: UseMutationOptions<Blob, Error, string>
) => {
  const documentApi = useApi<DocumentApi>('documentApi');

  return useMutation({
    mutationKey: ['generate-document'],
    mutationFn: (applicationId: string) => documentApi.generate(applicationId),
    cacheTime: 0,
    ...options,
  });
};
